import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators, UntypedFormBuilder, AbstractControl, ValidatorFn } from '@angular/forms';
import { UsersService } from '../../users.service';
import { Router, ActivatedRoute } from '@angular/router';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { cloneDeep, each, findIndex, filter, has, orderBy, isEqual, pickBy, identity, isNumber } from 'lodash';
import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';

import { fieldsUserDescription } from './users-create-edit-widget';
import { ConfirmModalComponent } from '../../../../shared/modals/confirm-modal/confirm-modal.component';
import { USERS_PATHS } from '../../users';
import { Enums } from '../../../../configs/Enums';
import { environment } from '../../../../../environments/environment.prod';
import { MaskReplace } from '../../../../utils/mask-replace';
import { AuthService } from '../../../auth/auth.service';
import { AuthDataInterface } from '../../../auth/auth';
import { ICheckEmployeeResponse } from '../../../../interfaces/check-employee-response.interface';
import { IDuplicateBy } from '../../../../interfaces/duplicate-by.interface';
import { AuthGroupTypesEnum } from '../../../auth/auth-group-types.enum';

function coordinateValidator(min: number, max: number): ValidatorFn {
  return (control: AbstractControl) => {
    const value = control.value;

    if (value === null || value === undefined || value === '') {
      return null;
    }

    const coordinate = Number(String(value).replace(',', '.'));

    return Number.isFinite(coordinate) && coordinate >= min && coordinate <= max
      ? null
      : { coordinate: true };
  };
}

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-users-create-edit-widget',
  templateUrl: './users-create-edit-widget.component.html',
  styleUrls: ['./users-create-edit-widget.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class UsersCreateEditWidgetComponent implements OnInit {
  public environment = environment;
  public authData;
  public userCreateEditForm: UntypedFormGroup;
  public currentDate: Date = new Date();
  public imagePreviewSrc;
  public image: any;
  public dataLoading: boolean;
  public fieldsInvalid;
  public fieldsDescription = fieldsUserDescription;
  public backendError: any;
  public duplicationError: IDuplicateBy;
  public companySelected;
  public serviceFunctionSelected;
  public branchSelected;
  public citySelected;
  public plotSelected;
  public companiesList;
  public serviceFunctionsList;
  public regionsList;
  public birthDateOptions = { maxDate: cloneDeep(this.currentDate) };
  public startWorkDateOptions = { maxDate: cloneDeep(this.currentDate) };
  public endWorkDateOptions = {
    minDate: null,
    maxDate: cloneDeep(this.currentDate),
  };
  public isEndWorkDateDisabled = true;
  public birthDateObj = { initDate: null, selectedDate: null };
  public startWorkDateObj = { initDate: null, selectedDate: null };
  public endWorkDateObj = { initDate: null, selectedDate: null };
  public userTypes;
  public userTypeSelected;
  public userStatuses;
  public userStatusSelected;
  public readonly qualificationCoefficients = Array.from({ length: 16 }, (_, index) => {
    const value = (index + 5) / 10;
    return { value, label: String(value).replace('.', ',') };
  });

  public get isAdministrator(): boolean {
    return this.authData?.current_group?.id === AuthGroupTypesEnum.Admin;
  }

  public get canEditCompany(): boolean {
    const roleId = Number(this.authData?.current_group?.id);
    return !!this.authData?.is_privileged || roleId === AuthGroupTypesEnum.Admin ||
      roleId === AuthGroupTypesEnum.Curator;
  }

  public get qualificationCoefficientSelected() {
    return this.qualificationCoefficients.find(
      coefficient => coefficient.value === this.userCreateEditForm.get('qualification_coefficient').value
    );
  }

  public roles;
  public defaultRoleSelected;
  public isEditMode: boolean;
  public userId;
  public versions;
  public currentSelectedUser;
  public isExistImage;
  public userSaveOrEditLoading = false;
  public rolesChecked = [];
  public roleSectorsOptions = [
    {
      id: AuthGroupTypesEnum.Admin,
      sector_role: 'm_t',
      name: 'Администратор',
      order: 1,
      options: {
        regions: {
          mode: 'multiple',
          is_visible: true,
          isLoading: false,
        },
        branches: {
          mode: 'multiple',
          is_visible: true,
          isLoading: false,
        },
        sectors: {
          mode: 'multiple',
          is_visible: true,
          isLoading: false,
        },
        isLoading: false,
      },
      data: {
        regions: [],
        branches: [],
        sectors: [],
      },
      selected: {
        regions: [],
        branches: [],
        sectors: [],
      },
    },
    {
      id: AuthGroupTypesEnum.Curator,
      sector_role: 'm_t',
      name: 'Куратор',
      order: 2,
      options: {
        regions: {
          mode: 'multiple',
          is_visible: true,
          isLoading: false,
        },
        branches: {
          mode: 'multiple',
          is_visible: true,
          isLoading: false,
        },
        sectors: {
          mode: 'multiple',
          is_visible: true,
          isLoading: false,
        },
        isLoading: false,
      },
      data: {
        regions: [],
        branches: [],
        sectors: [],
      },
      selected: {
        regions: [],
        branches: [],
        sectors: [],
      },
    },
    {
      id: AuthGroupTypesEnum.Dispatcher,
      sector_role: 'm_t',
      name: 'Диспетчер',
      order: 3,
      options: {
        regions: {
          mode: 'multiple',
          is_visible: true,
          isLoading: false,
        },
        branches: {
          mode: 'multiple',
          is_visible: true,
          isLoading: false,
        },
        sectors: {
          mode: 'multiple',
          is_visible: true,
          isLoading: false,
        },
        isLoading: false,
      },
      data: {
        regions: [],
        branches: [],
        sectors: [],
      },
      selected: {
        regions: [],
        branches: [],
        sectors: [],
      },
    },
    {
      id: AuthGroupTypesEnum.ServiceEngineer,
      sector_role: 'm_t',
      name: 'Сервис-инженер',
      order: 4,
      options: {
        regions: {
          mode: 'single',
          is_visible: true,
          isLoading: false,
        },
        branches: {
          mode: 'single',
          is_visible: true,
          isLoading: false,
        },
        sectors: {
          mode: 'single',
          is_visible: true,
          isLoading: false,
        },
      },
      data: {
        regions: [],
        branches: [],
        sectors: [],
      },
      selected: {
        regions: [],
        branches: [],
        sectors: [],
      },
    },
    {
      id: AuthGroupTypesEnum.DispatcherGRS,
      name: 'Диспетчер ГРРС',
      sector_role: 'grrs',
      order: 5,
      options: {
        regions: {
          mode: 'multiple',
          is_visible: true,
          isLoading: false,
        },
        branches: {
          mode: 'multiple',
          is_visible: true,
          isLoading: false,
        },
        sectors: {
          mode: 'multiple',
          is_visible: true,
          isLoading: false,
        },
      },
      data: {
        regions: [],
        branches: [],
        sectors: [],
      },
      selected: {
        regions: [],
        branches: [],
        sectors: [],
      },
    },
    {
      id: AuthGroupTypesEnum.ServiceEngineerGRS,
      name: 'Инженер ГРРС',
      sector_role: 'grrs',
      order: 6,
      options: {
        regions: {
          mode: 'single',
          is_visible: true,
          isLoading: false,
        },
        branches: {
          mode: 'single',
          is_visible: true,
          isLoading: false,
        },
        sectors: {
          mode: 'multiple',
          is_visible: true,
          isLoading: false,
        },
      },
      data: {
        regions: [],
        branches: [],
        sectors: [],
      },
      selected: {
        regions: [],
        branches: [],
        sectors: [],
      },
    },
  ];
  public rolesBlock = [];
  public dateShortFormat = Enums.dates.shortFormat;

  constructor(
    private fb: UntypedFormBuilder,
    public authService: AuthService,
    public usersService: UsersService,
    public modalService: NgbModal,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.route.paramMap.subscribe((params) => {
      this.userId = params.get('u_id');
      this.isEditMode = !!this.userId;

      if (this.userId) {
        this.getEditData();
      } else {
        this.getCreateData();
      }
    });

    this.authService.subscribeAuthData().subscribe((authData: AuthDataInterface) => {
      this.authData = authData;
      if (this.userCreateEditForm) {
        this.updatePersonnelNumberState();
      }
    });
  }

  private getEditData() {
    this.dataLoading = true;
    this.usersService.getEditUserUnion(this.userId).subscribe((response) => {
      this.companiesList = this.makeCompanies(response[0]['data']);
      this.serviceFunctionsList = response[1];
      this.regionsList = response[2]['data'].map((region) => {
        region.is_checked = false;
        return region;
      });
      this.userTypes = response[3]['data'];
      this.userStatuses = response[4]['data'];
      this.roles = response[5]['data'].map((r) => {
        r.is_checked = false;
        return r;
      });
      this.currentSelectedUser = response[6]['data'].user;

      if (isNumber(this.currentSelectedUser.employer.service_function)) {
        this.serviceFunctionSelected = this.serviceFunctionsList
          .find(sf => sf.service_function_id === this.currentSelectedUser.employer.service_function);
      }

      this.versions = response[6]['data'].versions;
      this.makeEditUserForm();

      this.dataLoading = false;
    });
  }

  private getCreateData() {
    this.dataLoading = true;
    this.usersService.getCreateUserUnion().subscribe((response) => {
      this.companiesList = this.makeCompanies(response[0]['data']);
      this.serviceFunctionsList = response[1];
      this.regionsList = response[2]['data'].map((region) => {
        region.is_checked = false;
        return region;
      });
      this.userTypes = response[3]['data'];
      this.userStatuses = response[4]['data'];
      this.roles = response[5]['data'].map((r) => {
        r.is_checked = false;
        return r;
      });
      this.makeCreateUserForm();

      this.dataLoading = false;
    });
  }

  private getBranches(roleBlock) {
    if (!roleBlock.selected.regions.length) {
      return;
    }

    roleBlock.options.branches.isLoading = true;
    const regions = roleBlock.selected.regions.map((region) => region.region);
    const sectorRoleParam = (
      roleBlock.id === AuthGroupTypesEnum.Curator ? {} : {sector_role: roleBlock.sector_role}
    );
    this.usersService.getMiscBranches({ regions, ...sectorRoleParam })
      .subscribe(
        (response) => {
          roleBlock.data.branches = response['data'];
          roleBlock.options.branches.isLoading = false;
        },
        (error) => {
          console.log(error);
          roleBlock.data.branches = [];
          roleBlock.options.branches.isLoading = false;
        }
    );
  }

  private getBranchesInit(roleBlock) {
    const regions = roleBlock.selected.regions.map((region) => region.region);
    return this.usersService.getMiscBranches({ regions });
  }

  private getSectors(roleBlock) {
    if (!roleBlock.selected.branches.length || !this.companySelected) {
      return;
    }

    const params = pickBy({
      partnership_id: this.companySelected.campaign_id,
      regions: roleBlock.selected.regions.map((region) => region.region),
      branches: roleBlock.selected.branches.map((b) => b.mb_id),
    }, identity);

    roleBlock.options.sectors.isLoading = true;
    const sectorRoleParam = (
      roleBlock.id === AuthGroupTypesEnum.Admin ? {} : {sector_role: roleBlock.sector_role}
    );
    this.usersService.getMiscSectors({...params, ...sectorRoleParam}).subscribe(
      (response) => {
        roleBlock.data.sectors = orderBy(response['data'], ['sector_number_str'], ['asc']);
        roleBlock.options.sectors.isLoading = false;
      },
      (error) => {
        console.log(error);
        roleBlock.data.sectors = [];
        roleBlock.options.sectors.isLoading = false;
      }
    );
  }

  private getSectorsInit(roleBlock) {
    const params = {
      partnership_id: this.companySelected.campaign_id,
      regions: roleBlock.selected.regions.map((region) => region.region),
      branches: roleBlock.selected.branches.map((b) => b.mb_id),
    };

    if (roleBlock.id !== AuthGroupTypesEnum.Curator &&
        roleBlock.id !== AuthGroupTypesEnum.Admin) {
      params['sector_role'] = roleBlock.sector_role;
    }

    return this.usersService.getMiscSectors(params);
  }

  private makeCompanies(companiesList) {
    return companiesList
      .filter((company) => company.is_visible)
      .map((company) => {
        company.new_company_name = company.ownership_type.ot_short + ' - ' + company.ps_name;

        return company;
      });
  }

  private makeCreateUserForm() {
    const companyCustomer = filter(this.companiesList, (company: any) => company.is_users_campaign);

    this.userCreateEditForm = new UntypedFormGroup({
      last_name: new UntypedFormControl('', Validators.required),
      first_name: new UntypedFormControl('', Validators.required),
      patronymic_name: new UntypedFormControl(''),
      birthday: new UntypedFormControl('', Validators.required),
      home_latitude: new UntypedFormControl('', coordinateValidator(-90, 90)),
      home_longitude: new UntypedFormControl('', coordinateValidator(-180, 180)),
      tf_status: new UntypedFormControl('0'),
      tf_model: new UntypedFormControl(''),
      tf_number: new UntypedFormControl(''),
      phone: new UntypedFormControl('', Validators.required),
      phone_additional: new UntypedFormControl(''),
      email: new UntypedFormControl('', Validators.required),
      partnership_id: new UntypedFormControl('', Validators.required),
      service_function_id: new UntypedFormControl('', Validators.required),
      personnel_number: new UntypedFormControl(''),
      emp_number: new UntypedFormControl('', Validators.required),
      qualification_coefficient: new UntypedFormControl(1, [Validators.required, Validators.min(0.5), Validators.max(2)]),
      employee_type: new UntypedFormControl('', Validators.required),
      status: new UntypedFormControl('', Validators.required),
      hire_date: new UntypedFormControl('', Validators.required),
      dismissal_date: new UntypedFormControl(''),
      dismissal_reason: new UntypedFormControl(''),
      token_number: new UntypedFormControl(''),
      role: new UntypedFormControl(false, Validators.required),
      default_group_id: new UntypedFormControl('', Validators.required),
      user_sectors: new UntypedFormControl([]),
    });

    this.changeStateTransportFields(0);
    this.checkEndWorkDate(null);
    this.getSubscribeUserFormFields();

    if (companyCustomer.length) {
      this.onChangeCompany(companyCustomer[0]);
    }
  }

  private makeEditUserForm() {
    const curUserData = this.currentSelectedUser;

    this.userCreateEditForm = new UntypedFormGroup({
      last_name: new UntypedFormControl(curUserData.employee.last_name, Validators.required),
      first_name: new UntypedFormControl(curUserData.employee.first_name, Validators.required),
      patronymic_name: new UntypedFormControl(curUserData.employee.patronymic_name),
      birthday: new UntypedFormControl(curUserData.employee.birthday, Validators.required),
      home_latitude: new UntypedFormControl(this.getEmployeeHomeCoordinate(curUserData, 'latitude'), coordinateValidator(-90, 90)),
      home_longitude: new UntypedFormControl(this.getEmployeeHomeCoordinate(curUserData, 'longitude'), coordinateValidator(-180, 180)),
      tf_status: new UntypedFormControl(curUserData.transport ? '1' : '0'),
      tf_model: new UntypedFormControl(curUserData.transport ? curUserData.transport.tf_model : null),
      tf_number: new UntypedFormControl(curUserData.transport ? curUserData.transport.tf_number : null),
      phone: new UntypedFormControl('', Validators.required),
      phone_additional: new UntypedFormControl(''),
      email: new UntypedFormControl(curUserData.employee.email, Validators.required),
      partnership_id: new UntypedFormControl(curUserData.employer.partnership_id, Validators.required),
      service_function_id: new UntypedFormControl(curUserData.employer.service_function_id, Validators.required),
      personnel_number: new UntypedFormControl(curUserData.employee.personnel_number),
      emp_number: new UntypedFormControl(curUserData.employee.emp_number, Validators.required),
      qualification_coefficient: new UntypedFormControl(
        Number(curUserData.employee.qualification_coefficient ?? 1),
        [Validators.required, Validators.min(0.5), Validators.max(2)]
      ),
      employee_type: new UntypedFormControl(curUserData.employer.employee_type, Validators.required),
      status: new UntypedFormControl(curUserData.employer.status, Validators.required),
      hire_date: new UntypedFormControl(curUserData.employer.hire_date, Validators.required),
      dismissal_date: new UntypedFormControl(curUserData.employer.dismissal_date),
      dismissal_reason: new UntypedFormControl(curUserData.employer.dismissal_reason),
      token_number: new UntypedFormControl(curUserData.employer.token_number),
      role: new UntypedFormControl('', Validators.required),
      default_group_id: new UntypedFormControl(curUserData.default_group_id, Validators.required),
      user_sectors: new UntypedFormControl([]),
    });

    this.changeStateTransportFields(curUserData.transport ? '1' : '0');
    this.checkEndWorkDate(null);
    this.getSubscribeUserFormFields();
    this.initUiData();
  }

  private getSubscribeUserFormFields() {
    this.userCreateEditForm.get('tf_status').valueChanges.subscribe((selectedValue) => {
      this.changeStateTransportFields(selectedValue);
    });
  }

  public onChangeNames(event, fieldName) {
    let val = event.target.value ? event.target.value.charAt(0).toUpperCase() + event.target.value.slice(1) : '';

    this.userCreateEditForm.controls[fieldName].setValue(
      val
        .replace(/^[^a-zA-Zа-яА-Я]+/, '')
        .replace(/[^a-zA-Zа-яА-Я '′-]+/g, '')
        .replace(/\s+/g, ' ')
    );
  }

  public getHomeMapUrl(): string | null {
    if (!this.userCreateEditForm) {
      return null;
    }

    const latitudeControl = this.userCreateEditForm.get('home_latitude');
    const longitudeControl = this.userCreateEditForm.get('home_longitude');

    if (
      !latitudeControl ||
      !longitudeControl ||
      latitudeControl.invalid ||
      longitudeControl.invalid ||
      latitudeControl.value === null ||
      latitudeControl.value === undefined ||
      latitudeControl.value === '' ||
      longitudeControl.value === null ||
      longitudeControl.value === undefined ||
      longitudeControl.value === ''
    ) {
      return null;
    }

    const latitude = Number(String(latitudeControl.value).replace(',', '.'));
    const longitude = Number(String(longitudeControl.value).replace(',', '.'));

    return `https://www.openstreetmap.org/?mlat=${latitude}&mlon=${longitude}#map=18/${latitude}/${longitude}`;
  }

  public openHomeCoordinateMap(): void {
    const url = this.getHomeMapUrl();

    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  }

  private getEmployeeHomeCoordinate(user, coordinate: 'latitude' | 'longitude') {
    const employee = (user && user.employee) || {};
    const field = `home_${coordinate}`;

    if (user && user[field] !== null && user[field] !== undefined) {
      return user[field];
    }

    if (employee[field] !== null && employee[field] !== undefined) {
      return employee[field];
    }

    const homeCoordinate = employee.home_coordinate || (user && user.home_coordinate);

    return homeCoordinate && homeCoordinate[coordinate] !== undefined ? homeCoordinate[coordinate] : '';
  }

  private initUiData() {
    let curUser = this.currentSelectedUser;
    let companyId = curUser.employer.partnership_id;
    let serviceFunctionId = curUser.employer.service_function_id;
    let typeId = curUser.employer.employee_type;
    let statusId = curUser.employer.status;
    let defaultRoleId = curUser.default_group_id;

    this.isExistImage = curUser.employee.photo || null;
    this.birthDateObj.initDate = moment(curUser.employee.birthday);

    each(curUser.phones, (phone) => {
      if (phone.priority === '1') {
        this.userCreateEditForm.controls['phone'].setValue(phone.phone);
      } else {
        this.userCreateEditForm.controls['phone_additional'].setValue(phone.phone);
      }
    });

    if (companyId) {
      let index = findIndex(this.companiesList, {
        campaign_id: companyId,
      });

      if (index > -1) {
        this.companySelected = this.companiesList[index];
        this.onChangeCompany(this.companiesList[index]);
      }
    }

    if (serviceFunctionId) {
      let index = findIndex(this.serviceFunctionsList, {
        service_function_id: serviceFunctionId,
      });

      if (index > -1) {
        this.serviceFunctionSelected = this.serviceFunctionsList[index];
        this.onChangeServiceFunction(this.serviceFunctionsList[index]);
      }
    }

    if (typeId) {
      let index = findIndex(this.userTypes, { et_id: typeId });

      if (index > -1) {
        this.userTypeSelected = this.userTypes[index];
        this.onChangeUserType(this.userTypes[index]);
      }
    }

    if (statusId) {
      let index = findIndex(this.userStatuses, { es_id: statusId });

      if (index > -1) {
        this.userStatusSelected = this.userStatuses[index];
        this.onChangeUserStatus(this.userStatuses[index]);

        this.checkEndWorkDate(this.userStatuses[index]);
      }
    }

    this.startWorkDateObj.initDate = moment(curUser.employer.hire_date);

    if (curUser.employer.dismissal_date) {
      this.endWorkDateObj.initDate = moment(curUser.employer.dismissal_date);
    }

    if (defaultRoleId) {
        let index = findIndex(this.roles, { id: defaultRoleId });

      if (index > -1) {
        this.defaultRoleSelected = this.roles[index];
        this.onChangeDefaultRole(this.roles[index]);
      }
    }

    if (curUser.groups && curUser.groups.length) {
      each(curUser.groups, (group) => {
        const roleIndex = findIndex(this.roles, { id: group });

        if (roleIndex > -1) {
          this.initRolesBlock(this.roles[roleIndex]);
        }
      });

      each(this.rolesBlock, (roleBlock) => {
        this.initRoleBlock(roleBlock);
      });

      this.rolesChecked = this.roles.filter((r) => r.is_checked);
    }
  }

  public changeStateTransportFields(selectedValue) {
    if (+selectedValue) {
      this.userCreateEditForm.controls['tf_model'].enable();
      this.userCreateEditForm.controls['tf_number'].enable();
    } else {
      this.userCreateEditForm.controls['tf_model'].disable();
      this.userCreateEditForm.controls['tf_number'].disable();
    }
  }

  private updatePersonnelNumberState() {
    const control = this.userCreateEditForm.controls['personnel_number'];
    const isEnabled = this.canEditCompany && !!this.companySelected;
    control.setValidators(isEnabled ? [Validators.required, Validators.pattern(/\S/)] : []);
    if (isEnabled) {
      control.enable();
    } else {
      control.disable();
    }
    control.updateValueAndValidity();
  }

  public onChangeBirthDate(dateObj) {
    this.birthDateObj.selectedDate = dateObj;
    this.userCreateEditForm.controls['birthday'].setValue(dateObj.dateMillis
      ? moment(dateObj.dateMillis).format(this.dateShortFormat)
      : null
    );

    if (dateObj.validationError) {
      this.userCreateEditForm.controls['birthday'].setErrors({
        checkAdultInvalid: true,
      });
    } else {
      this.userCreateEditForm.controls['birthday'].setErrors(null);
    }
  }

  public handleFileInput($event): void {
    let myReader: FileReader = new FileReader();
    let inputValue = $event.target;

    this.image = inputValue.files[0];
    this.isExistImage = !!this.image;

    myReader.onloadend = () => {
      this.imagePreviewSrc = myReader.result;
    };
    myReader.readAsDataURL(this.image);
  }

  public onRemovePreview() {
    this.image = null;
    this.imagePreviewSrc = null;
    this.isExistImage = null;
  }

  public onChangeCompany(company) {
    this.companySelected = company ? company : null;

    this.userCreateEditForm.controls['partnership_id'].setValue(company ? company.campaign_id : null);
    each(this.rolesBlock, (roleBlock) => {
      roleBlock.data.sectors = [];
      roleBlock.selected.sectors = [];
      this.getSectors(roleBlock);
    });

    this.updatePersonnelNumberState();
  }

  public onChangeServiceFunction(serviceFunction) {
    this.serviceFunctionSelected = serviceFunction ? serviceFunction : null;
    this.userCreateEditForm.controls['service_function_id'].setValue(serviceFunction ? serviceFunction.service_function_id : null);
  }

  public onChangeUserType(type) {
    this.userTypeSelected = type ? type : null;
    this.userCreateEditForm.controls['employee_type'].setValue(type ? type.et_id : null);
  }

  public onChangeUserStatus(status) {
    this.userStatusSelected = status ? status : null;
    this.userCreateEditForm.controls['status'].setValue(status ? status.es_id : null);

    this.checkEndWorkDate(status);
  }

  private checkEndWorkDate(status) {
    if (status && status.es_id === 2) {
      this.userCreateEditForm.controls['dismissal_date'].enable();
      this.userCreateEditForm.controls['dismissal_date'].setValidators([Validators.required]);
      this.userCreateEditForm.controls['dismissal_reason'].enable();
      this.userCreateEditForm.controls['dismissal_reason'].setValidators([Validators.required]);
      this.isEndWorkDateDisabled = false;
      this.isEndWorkDateDisabled = false;
    } else {
      this.userCreateEditForm.controls['dismissal_date'].disable();
      this.userCreateEditForm.controls['dismissal_date'].clearValidators();
      this.userCreateEditForm.controls['dismissal_reason'].disable();
      this.userCreateEditForm.controls['dismissal_reason'].clearValidators();
      this.isEndWorkDateDisabled = true;
    }

    this.userCreateEditForm.controls['dismissal_date'].updateValueAndValidity();
    this.userCreateEditForm.controls['dismissal_reason'].updateValueAndValidity();
  }

  private initRolesBlock(role) {
    role.is_checked = true;
    this.someRoleCheckedValidation();
    this.makeRoleBlock(role);
  }

  private initRoleBlock(roleBlock) {
    let curUser = this.currentSelectedUser;
    let roleInitData = filter(curUser.user_sectors, (r: any) => r.group === roleBlock.id);
    let roleBlockData = roleBlock.data;
    let roleSelected = roleBlock.selected;

    if (roleInitData && roleInitData.length && roleInitData.length === 1) {
      let data = roleInitData[0];

      each(data['regions'], (regionName) => {
        let regionIndex = findIndex(roleBlockData.regions, {
          region: regionName,
        });

        if (regionIndex > -1) {
          roleBlockData.regions[regionIndex]['is_checked'] = true;
        }
      });

      roleSelected.regions = filter(roleBlockData.regions, (region: any) => region.is_checked);
      this.getBranchesInit(roleBlock).subscribe((response) => {
        roleBlockData.branches = response['data'];

        each(data['branches'], (branch) => {
          let branchIndex = findIndex(roleBlockData.branches, {
            mb_id: branch,
          });

          if (branchIndex > -1) {
            roleBlockData.branches[branchIndex]['is_checked'] = true;
          }
        });

        roleSelected.branches = filter(roleBlockData.branches, (branch: any) => branch.is_checked);
        this.getSectorsInit(roleBlock).subscribe((responseSectors) => {
          roleBlockData.sectors = responseSectors['data'];

          each(data['sectors'], (sector) => {
            let sectorIndex = findIndex(roleBlockData.sectors, {
              sector_id: sector,
            });

            if (sectorIndex > -1) {
              roleBlockData.sectors[sectorIndex]['is_checked'] = true;
            }
          });

          roleSelected.sectors = filter(roleBlockData.sectors, (s: any) => s.is_checked);
        });
      });
    }
  }

  public onChangeDefaultRole(role) {
    this.defaultRoleSelected = role ? role : null;
    this.userCreateEditForm.controls['default_group_id'].setValue(role ? role.id : null);
  }

  public onChangeRoles(event, role) {
    if (!event) {
      return;
    }

    role.is_checked = event.target.checked;
    this.someRoleCheckedValidation();
    this.setDefaultRole();
    this.makeRoleBlock(role);
  }

  private someRoleCheckedValidation() {
    this.userCreateEditForm.controls['role'].setValue(this.roles.filter((r) => r.is_checked).length > 0);
  }

  private setDefaultRole() {
    const roleChecked = this.roles.filter((r) => r.is_checked);
    this.rolesChecked = roleChecked;

    if (roleChecked.length === 1) {
      this.onChangeDefaultRole(roleChecked[0]);
    } else {
      if (this.defaultRoleSelected) {
        let index = findIndex(roleChecked, {
          id: this.defaultRoleSelected.id,
        });

        if (index === -1) {
          this.defaultRoleSelected = null;
          this.onChangeDefaultRole(null);
        }
      }
    }
  }

  private makeRoleBlock(role) {
    if (role.is_checked) {
      const template = cloneDeep(this.roleSectorsOptions[findIndex(this.roleSectorsOptions, { id: role.id })]);
      template.data.regions = cloneDeep(this.regionsList);

      this.rolesBlock.push(template);
      this.rolesBlock = orderBy(this.rolesBlock, ['order', 'asc']);
    } else {
      this.rolesBlock.splice(findIndex(this.rolesBlock, { id: role.id }), 1);
    }
  }

  public onCloseSearchPopover(roleBlock, group) {
    switch (group) {
      case 'regions':
        let selectedRegions = filter(roleBlock.data.regions, (region: any) => region.is_checked);

        if (!isEqual(selectedRegions, roleBlock.selected.regions)) {
          roleBlock.selected.regions = selectedRegions;
          roleBlock.selected.branches = [];
          roleBlock.data.branches = [];
          roleBlock.selected.sectors = [];
          roleBlock.data.sectors = [];
          this.getBranches(roleBlock);
        }
        break;
      case 'branches':
        let selectedBranches = filter(roleBlock.data.branches, (branch: any) => branch.is_checked);

        if (!isEqual(selectedBranches, roleBlock.selected.branches)) {
          roleBlock.selected.branches = selectedBranches;
          roleBlock.selected.sectors = [];
          roleBlock.data.sectors = [];
          this.getSectors(roleBlock);
        }
        break;
      case 'sectors':
        roleBlock.selected.sectors = filter(roleBlock.data.sectors, (sector: any) => sector.is_checked);
        break;
      default:
        break;
    }
  }

  public onChangeStartWorkDate(dateObj) {
    const obj = { minDate: null, maxDate: this.endWorkDateOptions.maxDate };
    obj.minDate = dateObj && dateObj.dateMillis ? moment(dateObj.dateMillis)['_d'] : this.currentDate;

    this.endWorkDateOptions = obj;
    this.startWorkDateObj.selectedDate = dateObj;
    this.userCreateEditForm.controls['hire_date'].setValue(dateObj.dateMillis
      ? moment(dateObj.dateMillis).format(this.dateShortFormat)
      : null
    );
  }

  public onChangeEndWorkDate(dateObj) {
    this.endWorkDateObj.selectedDate = dateObj;
    this.userCreateEditForm.controls['dismissal_date'].setValue(dateObj.dateMillis
      ? moment(dateObj.dateMillis).format(this.dateShortFormat)
      : null
    );
  }

  private checkErrors() {
    const fieldsInvalid = [];

    each(this.userCreateEditForm.controls, (value, key) => {
      if (this.userCreateEditForm.controls[key].invalid) {
        fieldsInvalid.push(key);
      }
    });

    each(this.rolesBlock, (block) => {
      each(block.selected, (value, key) => {
        if (!value.length) {
          const fieldsMap = Object.create(null);
          fieldsMap['regions'] = 'Регион';
          fieldsMap['branches'] = 'Филиал';
          fieldsMap['sectors'] = 'Участок';

          const field = {
            step: 2,
            sectionName: 'Участки',
            subSectionName: 'Для роли "' + block.name + '"',
            fieldName: fieldsMap[key],
          };
          const fieldFakeName = block.id + '_' + key;
          this.fieldsDescription[fieldFakeName] = field;
          fieldsInvalid.push(fieldFakeName);
        }
      });
    });

    return fieldsInvalid;
  }

  private setUserSectors() {
    let userSectors = [];

    each(this.rolesBlock, (roleBlock) => {
      userSectors.push({
        group_id: roleBlock.id,
        branches: roleBlock.selected.branches.map(b => b.mb_id),
        regions: roleBlock.selected.regions.map(r => r.region),
        sectors: roleBlock.selected.sectors.map((s) => s.sector_id),
      });
    });

    this.userCreateEditForm.controls['user_sectors'].setValue(userSectors);
  }

  public onSaveStepsCallback() {
    const fieldsInvalid = this.checkErrors();

    this.fieldsInvalid = null;
    this.backendError = null;
    this.fieldsInvalid = fieldsInvalid;
    this.setUserSectors();

    if (!fieldsInvalid.length) {
      const CIIndex = findIndex(this.rolesBlock, { id: 4 });

      if (this.isEditMode || CIIndex > -1) {
        const confirmCloseStepsComponent = this.modalService.open(ConfirmModalComponent, {
          ariaLabelledBy: 'modal-basic-title',
          windowClass: 'modal-wrapper',
          backdrop: 'static',
        });

        const curUser = this.currentSelectedUser;

        confirmCloseStepsComponent.componentInstance.title = 'Подтвердите сохранение';
        if (CIIndex > -1) {
          confirmCloseStepsComponent.componentInstance.description =
            'Участки дополнительных ролей будут' +
            ' заменены на один участок, выбранный для роли “Сервис-Инженер”. Вы действительно хотите' +
            ' сохранить профиль сотрудника с этими изменениями?';
        } else {
          confirmCloseStepsComponent.componentInstance.description =
            'Вы внесли изменения в профиль пользователя ' +
            curUser.employee.last_name +
            ' ' +
            curUser.employee.first_name +
            ' ' +
            curUser.employee.patronymic_name +
            '. ' +
            'Вы действительно хотите сохранить профиль?';
        }

        confirmCloseStepsComponent.componentInstance.successButtonName = 'Да, сохранить';
        confirmCloseStepsComponent.componentInstance.abortButtonName = 'Отмена';

        confirmCloseStepsComponent.result.then(
          () => {
            this.cloneSectorsBlock(CIIndex);
          },
          () => {}
        );
      } else {
        this.cloneSectorsBlock(CIIndex);
      }
    }
  }

  private cloneSectorsBlock(CIIndex) {
    if (CIIndex > -1) {
      const ci = this.rolesBlock[CIIndex];
      each(this.rolesBlock, (roleBlock) => {
        if (roleBlock.id !== 4) {
          roleBlock.selected.regions = cloneDeep(ci.selected.regions);
          roleBlock.selected.branches = cloneDeep(ci.selected.branches);
          roleBlock.selected.sectors = cloneDeep(ci.selected.sectors);
          roleBlock.data.regions = cloneDeep(ci.data.regions);
          roleBlock.data.branches = cloneDeep(ci.data.branches);
          roleBlock.data.sectors = cloneDeep(ci.data.sectors);
        }
      });
    }

    this.createOrEditUser();
  }

  public onResetStepsCallback() {
    const confirmCloseStepsComponent = this.modalService.open(ConfirmModalComponent, {
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'modal-wrapper',
      backdrop: 'static',
    });

    confirmCloseStepsComponent.componentInstance.title = 'Подтвердите выход без сохранения';
    confirmCloseStepsComponent.componentInstance.description = (
      'Вся введенная вами информация будет утеряна.' + ' Вы действительно хотите покинуть страницу без сохранения?'
    );
    confirmCloseStepsComponent.componentInstance.successButtonName = 'Да, выйти';
    confirmCloseStepsComponent.componentInstance.abortButtonName = 'Отмена';

    confirmCloseStepsComponent.result.then(
      () => {
        this.router.navigate([USERS_PATHS.users]);
      },
      () => {}
    );
  }

  public handleFocusOut(): void {
    this.checkDuplicates().subscribe(({ data }) => {
      this.duplicationError = data;
    });
  }

  private makeCreateOrEditData() {
    let userForm = this.userCreateEditForm.value;
    let requestObj = {
      u_id: this.isEditMode ? this.currentSelectedUser.u_id : null,
      groups: this.rolesChecked.map((r) => r.id),
      user_sectors: userForm.user_sectors,
      default_group_id: userForm.default_group_id,
      phones: [
        {
          phone: MaskReplace.replace(userForm.phone, 'phone'),
          priority: 1,
        },
      ],
      transport:
        userForm.tf_status === '1'
          ? {
              tf_model: userForm.tf_model,
              tf_number: userForm.tf_number,
            }
          : null,
      employer: {
        partnership_id: userForm.partnership_id,
        service_function_id: userForm.service_function_id,
        hire_date: userForm.hire_date,
        dismissal_date: userForm.dismissal_date || null,
        dismissal_reason: userForm.dismissal_reason || null,
        token_number: userForm.token_number,
        status: userForm.status,
        employee_type: userForm.employee_type,
      },
      employee: {
        last_name: userForm.last_name,
        first_name: userForm.first_name,
        patronymic_name: userForm.patronymic_name,
        birthday: userForm.birthday,
        emp_number: String(userForm.emp_number),
        email: userForm.email,
        personnel_number: String(this.userCreateEditForm.controls['personnel_number'].value ?? '').trim() || null,
        ...(this.isAdministrator ? { qualification_coefficient: userForm.qualification_coefficient } : {}),
        photo: null,
      },
      employee_address: {
        home_latitude: this.normalizeCoordinate(userForm.home_latitude),
        home_longitude: this.normalizeCoordinate(userForm.home_longitude),
      },
    };

    if (userForm.phone_additional) {
      requestObj.phones.push({
        phone: userForm.phone_additional,
        priority: 0,
      });
    }

    if (this.isEditMode && !this.image) {
      requestObj.employee.photo = this.isExistImage ? this.currentSelectedUser.employee.photo : null;
    }

    return requestObj;
  }

  private normalizeCoordinate(value): number | null {
    return value === null || value === undefined || value === ''
      ? null
      : Number(String(value).replace(',', '.'));
  }

  private checkDuplicates(): Observable<ICheckEmployeeResponse> {
    let userForm = this.userCreateEditForm.value;

    let params = new HttpParams({
      fromObject: {
        phone: MaskReplace.replace(userForm.phone, 'phone') || '',
        email: userForm.email || '',
        personnel_number: userForm.personnel_number || '',
        emp_no: userForm.emp_number || '',
      },
    });

    return this.usersService.checkDuplicates(params);
  }

  private createOrEditUser() {
    const fieldsInvalid = this.checkErrors();
    if (fieldsInvalid.length) {
      this.fieldsInvalid = fieldsInvalid;
      return;
    }
    const requestObj = this.makeCreateOrEditData();

    this.backendError = null;
    this.userSaveOrEditLoading = true;
    this.usersService.createOrUpdateUser(requestObj).subscribe(
      (response) => {
        if (this.image) {
          let resp = response['data'];
          let formData = new FormData();
          formData.append('file_upload', this.image);
          this.usersService.uploadUserPhoto(resp.e_id, formData).subscribe(() => {
            this.router.navigate(['/' + USERS_PATHS.users]);

            this.dataLoading = true;
          });
        } else {
          this.router.navigate(['/' + USERS_PATHS.users]);

          this.userSaveOrEditLoading = false;
        }
      },
      (error) => {
        if (has(error, 'error.data.employee.email')) {
          this.backendError = error.error.data.employee.email;
        }

        if (has(error, 'error.data.employee.birthday')) {
          this.backendError = error.error.data.employee.birthday;
        }

        if (has(error, 'error.data.login')) {
          this.backendError = error.error.data.login;
        }

        if (has(error, 'error.data.transport.tf_number')) {
          this.backendError = error.error.data.transport.tf_number;
        }

        if (has(error, 'error.data.user_sectors')) {
          this.backendError = error.error.data.user_sectors;
        }

        if (has(error, 'error.data.user_brigade')) {
          this.backendError = error.error.data.user_brigade;
        }

        if (has(error, 'error.data.emp_number')) {
          this.backendError = error.error.data.emp_number;
        }

        if (!this.backendError) {
          this.backendError = Enums.errorCodes[Enums.errorCodesMaps['BACKEND_ERROR']];
        }

        this.userSaveOrEditLoading = false;
      }
    );
  }
}
